// extracted by mini-css-extract-plugin
var _1 = "zsprjGPIvnFB1QVDLaKI";
var _2 = "spUIuYmvi6e4U5pwnqB6";
var _3 = "ypKCUJUgEsiq9Lvs_Z3t";
var _4 = "CVL2ClC0iQ62h465rZD4";
var _5 = "Hjdb6PqeR8__SlXo4S8a";
var _6 = "VMCJc1KdJYLX9vhZA0mo";
var _7 = "TA0zsFVZ8dK1mP2_xM7r";
var _8 = "X8YeovsK5nb01Dw6Ec2A";
var _9 = "VMkGyJxpnM6DUFY4oOD_";
var _a = "B78mU1z8TqwyUR7cqRc8";
export { _1 as "auth_wrap", _2 as "buttons", _3 as "check", _4 as "img", _5 as "left_area", _6 as "logo", _7 as "right_area", _8 as "root", _9 as "signup_content", _a as "signup_content_count" }
